"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setInitial = exports.setFields = exports.setErrors = exports.resetChanged = exports.reset = exports.handleOnChange = exports.changeStatus = exports.formSlice = void 0;
const rc_utils_1 = require("@hangar31/rc-utils");
const toolkit_1 = require("@reduxjs/toolkit");
// Define the initial state using that type
const initialState = {
    changedData: {},
    errors: [],
    fields: {},
    initialData: {},
    status: 'WAITING',
};
exports.formSlice = (0, toolkit_1.createSlice)({
    initialState,
    name: 'form',
    reducers: {
        changeStatus: (state, action) => {
            state.status = action.payload;
        },
        handleOnChange: (state, action) => {
            const { name, value } = action.payload;
            // set the fields by the path name
            (0, rc_utils_1.setByPath)(state.fields, name, value);
            (0, rc_utils_1.setByPath)(state.changedData, name, value);
        },
        reset: state => {
            state.fields = state.initialData;
            state.changedData = {};
            state.status = 'WAITING';
        },
        resetChanged: state => {
            state.changedData = {};
        },
        setErrors: (state, action) => {
            state.errors = action.payload;
        },
        setFields: (state, action) => {
            const setters = action.payload;
            setters.forEach(setter => {
                (0, rc_utils_1.setByPath)(state.fields, setter[0], setter[1]);
                (0, rc_utils_1.setByPath)(state.changedData, setter[0], setter[1]);
            });
        },
        setInitial: (state, action) => {
            state.initialData = action.payload;
            state.fields = action.payload;
            state.status = 'WAITING';
        },
        update: (state, action) => {
            state.initialData = action.payload || state.fields;
            state.fields = action.payload || state.fields;
        },
    },
});
// Action creators are generated for each case reducer function
_a = exports.formSlice.actions, exports.changeStatus = _a.changeStatus, exports.handleOnChange = _a.handleOnChange, exports.reset = _a.reset, exports.resetChanged = _a.resetChanged, exports.setErrors = _a.setErrors, exports.setFields = _a.setFields, exports.setInitial = _a.setInitial, exports.update = _a.update;
exports.default = exports.formSlice.reducer;
